export default {
	'sign-in': 'Sign in',
	username: 'Username',
	password: 'Password',
}